export default "__VITE_ASSET__BEfnYi4g__"